import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

const PrivateRoute = props => {
  const {
    component: Component,
    path,
    excludePagePermissionCheck,
    ...rest
  } = props;
  const isLoggedin = useSelector(state => !!state.session.currentUser);
  const pages = useSelector(state => state.session.permission.pages);

  const render = renderProps => {
    if (isLoggedin) {
      if (!excludePagePermissionCheck && !pages.has(path)) {
        return <Redirect to="/" />;
      }

      return <Component {...renderProps} />;
    }
    return <Redirect to="/login" />;
  };

  return <Route {...rest} render={render} />;
};

PrivateRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  excludePagePermissionCheck: PropTypes.bool,
  path: PropTypes.string.isRequired,
};

PrivateRoute.defaultProps = {
  excludePagePermissionCheck: false,
};

export default PrivateRoute;
